export const SIDEBAR_WIDTH = 270;
export const NEW_FOLDER_ID = '__NEW__';
